import { inject } from '@angular/core';
import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { ActivityWatcher } from '../activity-watcher.service';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const activityWatcher = inject(ActivityWatcher);

  const exclude = ['/api/auth'];
  const startTime = new Date();
  if (!exclude.includes(req.url)) {
    activityWatcher.addRequest(req, startTime);
  }
  return next(req).pipe(
    tap(
      (response) => {
        if (response instanceof HttpResponse) {
          if (!exclude.includes(req.url)) {
            activityWatcher.addResponse(response, startTime);
          }
        }
      },
      (err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            if (!exclude.includes(req.url)) {
              activityWatcher.addError(err, startTime);
            }
            return;
          }
          console.warn('Unauthenticated response detected...navigating to login...');

          if (authService.redirectUrl.includes('portal')) {
            authService.navigateToFamilyLogin();
          } else if (authService.redirectUrl.includes('userType=ivrs')) {
            authService.navigateToVrLogin();
          } else {
            authService.navigateToLogin();
          }
        }
      }
    )
  );
};
